import type { CSSProperties } from "react"
import type { ImmutableLike, StyleSpecification } from "react-map-gl/mapbox"

import { GeometryDrawMode, MapStyle } from "./enums"

export const mapStyleSpecifications: Record<MapStyle, string | StyleSpecification | ImmutableLike<StyleSpecification>> =
	{
		[MapStyle.LIGHT]: import.meta.env.REACT_APP_MAPBOX_LIGHT_STYLE,
		[MapStyle.DARK]: import.meta.env.REACT_APP_MAPBOX_DARK_STYLE,
		[MapStyle.SATELLITE]: import.meta.env.REACT_APP_MAPBOX_SATELLITE_STYLE,
		[MapStyle.NONE]: Object.freeze({
			version: 8,
			sources: {},
			layers: [],
			sprite: "mapbox://sprites/davidandronache/cl0hg6kw4001614mg515eg7p7/3g6e03r5ha051bdoukyvgohh7",
		}),
	}

export const mapStyleColorMapping: Record<MapStyle, string> = {
	[MapStyle.LIGHT]: "#262424",
	[MapStyle.DARK]: "#eae3e3",
	[MapStyle.SATELLITE]: "#eae3e3",
	[MapStyle.NONE]: "#eae3e3",
}

export const GEOMETRY_DRAW_MODE_INSTRUCTIONS: Record<GeometryDrawMode, string> = {
	[GeometryDrawMode.POINT]: "Click on the map to place a point.",
	[GeometryDrawMode.LINE]: "Click to add points. Click the first point to complete the line.",
	[GeometryDrawMode.POLYGON]: "Click to add points. Click the first point to close the shape.",
	[GeometryDrawMode.RECTANGLE]: "Click to set the first corner, then click again to complete.",
	[GeometryDrawMode.CIRCLE]: "Click to set the center, then click again to set the radius.",
	[GeometryDrawMode.SECTOR]: "Click to set the center, then click to set the radius and arc.",
	[GeometryDrawMode.ELLIPSE]: "Click to set the center, then click to set the size.",
	[GeometryDrawMode.DISC]: "Click to set the center, then click to set the outer radius.",
	[GeometryDrawMode.DIAMOND]: "Click to set the center, then click to set the size.",
}

export const mapStyleDataMapping: Record<
	MapStyle,
	{
		label: string
		src: string
		defaultStyle?: CSSProperties
		selectedStyle?: CSSProperties
	}
> = {
	[MapStyle.LIGHT]: {
		label: "Sun",
		src: "/mapthumbnails/light.png",
	},
	[MapStyle.DARK]: {
		label: "Moon",
		src: "/mapthumbnails/dark.png",
	},
	[MapStyle.SATELLITE]: {
		label: "Earth",
		src: "/mapthumbnails/satellite.png",
	},
	[MapStyle.NONE]: {
		label: "Data Saver",
		src: "",
		defaultStyle: {
			background: "radial-gradient(circle at center, #ECECEC 0, white 100%)",
		},
		selectedStyle: {
			background: "radial-gradient(circle at center, #ECECEC 0, white 100%)",
		},
	},
}
